module.exports = __webpack_public_path__ + "static/media/icono (8).9d72805b.svg";